var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "status_bar"
  }, [_vm._v(" " + _vm._s(_vm.$store.state.statusMessage ? _vm.$store.state.statusMessage : "更新しました") + " ")]);
};
var staticRenderFns = [];
export { render, staticRenderFns };